import { TranslateService } from "@ngx-translate/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { DynamicTranslationDialogComponent } from "./dynamic-translation-dialog/dynamic-translation-dialog.component";

export function checkLocalizationLang(translate: TranslateService, lang=translate.currentLang, country){
    // // if(lang=='de' || lang == 'au' || lang == 'ch'){

      return lang;

}

export function openTranslationModal(modalService: BsModalService, key: string, result: any, fieldName: string, isMultiLine = false, maxlength: number = 150): BsModalRef {
  const languages: string[] = ['en', 'de', 'fr','cs','sk', 'hu', 'es', 'it', 'nl',  'ca','pt'] // sometimes in future defined in database
  const initialState = { key, languages: result, isMultiLine, maxlength, fieldName };
  languages.forEach(lang => {
    if (!initialState.languages[lang]) initialState.languages[lang] = ''
  })
  return modalService.show(DynamicTranslationDialogComponent, { initialState, class: 'translation-modal' });
}

// interface LanguageTranslation {
//   language: string;
//   value: string;
// }
